<ul class="settingsSite__tabs">
  @for (tab of accountSettingsTabs; track tab) {
    @if (!tab.hidden || showHiddenOptions) {
      <li
        class="settingsSite__tab"
        routerLinkActive="settingsSite__tab--active"
        [attr.data-m-target]="tab.dataTarget"
        >
        <a
          class="settingsSite__tab-link"
          [routerLink]="['/settings/account/', ppAccountId, tab.path]"
          >
          {{ tab.translationKey | ppTranslate }}
        </a>
      </li>
    }
  }
</ul>
